// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"26e223b6","832":"a85ebe55"}[chunkId] + ".chunk.js";
};